(() => {
  const root = document.querySelector('[data-dhc-email-popup]');
  if (!root) return;

  const STORAGE_KEY = 'dhc_email_popup_dismissed_until';
  const SUCCESS_KEY = 'dhc_email_popup_subscribed';
  const dialog = root.querySelector('.dhc-email-popup__dialog');
  const email = root.querySelector('input[type="email"]');
  const closeButtons = root.querySelectorAll('[data-dhc-email-close]');
  const copyButton = root.querySelector('[data-dhc-copy-code]');
  const codeEl = root.querySelector('[data-dhc-email-code]');
  const shopButton = root.querySelector('[data-dhc-email-shop]');
  const isSuccess = root.dataset.success === 'true';
  const discountCode = (root.dataset.discountCode || '').trim();
  const APPLY_KEY = 'dhc_email_popup_discount_applied';
  const delay = Math.max(0, Number(root.dataset.delay || 15)) * 1000; // B91: respect Theme Editor delay
  const scrollTrigger = Math.max(20, Number(root.dataset.scroll || 40));
  const dismissDays = Math.max(1, Number(root.dataset.dismissDays || 7));
  const testMode = /(?:\?|&)gus_popup_test=1(?:&|$)/.test(window.location.search);
  let opened = false;
  let lastFocus = null;

  const now = () => Date.now();
  const getDismissedUntil = () => {
    try { return Number(localStorage.getItem(STORAGE_KEY) || 0); }
    catch (_) { return 0; }
  };
  const alreadySubscribed = () => {
    try { return localStorage.getItem(SUCCESS_KEY) === '1'; }
    catch (_) { return false; }
  };
  const rememberDismissal = () => {
    try {
      localStorage.setItem(STORAGE_KEY, String(now() + dismissDays * 86400000));
    } catch (_) {}
  };
  const rememberSuccess = () => {
    try { localStorage.setItem(SUCCESS_KEY, '1'); }
    catch (_) {}
  };

  const applyDiscountToCart = async () => {
    if (!discountCode) return {ok:false, reason:'missing_code'};
    const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    try {
      const response = await fetch(base + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({discount: discountCode})
      });
      if (!response.ok) return {ok:false, reason:'http_' + response.status};
      const cart = await response.json();
      try {
        sessionStorage.setItem(APPLY_KEY, '1');
        sessionStorage.setItem('dhc_active_signup_discount', discountCode);
      } catch (_) {}
      document.dispatchEvent(new CustomEvent('dhc:discount-applied', {detail:{code:discountCode, cart:cart}}));
      document.dispatchEvent(new CustomEvent('cart:refresh', {detail:{source:'dhc-signup-discount'}}));
      return {ok:true, cart};
    } catch (_) {
      return {ok:false, reason:'network'};
    }
  };

  const open = (force = false) => {
    if (opened) return;
    if (!force && !testMode && (alreadySubscribed() || getDismissedUntil() > now())) return;
    opened = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('dhc-email-popup-open');
    requestAnimationFrame(() => {
      dialog?.focus({preventScroll:true});
      if (!isSuccess && email && window.matchMedia('(min-width: 750px)').matches) {
        setTimeout(() => email.focus({preventScroll:true}), 160);
      }
    });
  };

  const close = (remember = true) => {
    if (root.hidden) return;
    root.hidden = true;
    document.documentElement.classList.remove('dhc-email-popup-open');
    if (remember) rememberDismissal();
    lastFocus?.focus?.({preventScroll:true});
  };

  if (isSuccess) {
    rememberSuccess();

    let discountAlreadyApplied = false;
    try { discountAlreadyApplied = sessionStorage.getItem(APPLY_KEY) === '1'; } catch (_) {}

    if (!discountAlreadyApplied && discountCode) {
      applyDiscountToCart().finally(() => open(true));
    } else {
      open(true);
    }
  } else if (testMode || !alreadySubscribed()) {
    setTimeout(() => open(), delay);

    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      if (max <= 0) return;
      if ((window.scrollY / max) * 100 >= scrollTrigger) {
        window.removeEventListener('scroll', onScroll);
        open();
      }
    };
    window.addEventListener('scroll', onScroll, {passive:true});

    if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      document.addEventListener('mouseout', (e) => {
        if (e.clientY <= 0 && !e.relatedTarget) open();
      }, {once:true});
    }
  }

  closeButtons.forEach(btn => btn.addEventListener('click', () => close(true)));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !root.hidden) close(true);
    if (e.key !== 'Tab' || root.hidden || !dialog) return;
    const focusables = [...dialog.querySelectorAll('button,a[href],input:not([disabled]),[tabindex]:not([tabindex="-1"])')]
      .filter(el => !el.hidden && el.offsetParent !== null);
    if (!focusables.length) return;
    const first = focusables[0], last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  copyButton?.addEventListener('click', async () => {
    const code = codeEl?.textContent?.trim();
    if (!code) return;
    try {
      await navigator.clipboard.writeText(code);
      copyButton.textContent = 'Copied!';
      setTimeout(() => copyButton.textContent = 'Copy', 1600);
    } catch (_) {
      const range = document.createRange();
      range.selectNodeContents(codeEl);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    }
  });

  shopButton?.addEventListener('click', rememberSuccess);
})();